import type { LogicCondition } from '@webapp/common/entities/logic';

import type { Page } from '../common';

export interface LogicState {
    pages: Array<Page>; // TODO use pages from step1
    logics: Array<LogicCondition>;
    extednedLogics: Array<LogicCondition>;
    fetch: boolean;
    fetchExtendedLogics: boolean;
    lastAddedExtendedConditionId: number | null;
    fetchLogics: boolean;
    fetchPages: boolean;
}

export const initialState: LogicState = {
    pages: [],
    logics: [],
    extednedLogics: [],
    fetch: false,
    fetchExtendedLogics: true,
    lastAddedExtendedConditionId: null,
    fetchLogics: true,
    fetchPages: true,
};
